<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto dashboard-card" height="200" elevation="4">
      <v-card-text class="card-header">
        <v-icon class="mr-2" color="primary darken-1">mdi-account-clock</v-icon>
        <span class="text-h6 font-weight-medium">Matrículas Iniciais</span>
      </v-card-text>
      <v-row class="card-content" justify="center">
        <v-col cols="12" class="text-center">
          <div class="d-flex align-center justify-center">
            <v-card-text class="text-h2 font-weight-bold primary--text">
              {{ qtd ?? 0 }}
            </v-card-text>
          </div>
          <v-card-text class="text-caption grey--text">
            <span class="text-caption">Matriculas criadas até o dia 05/02/{{ anoAtual }}</span>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    franquiaId: {
      type: Number,
    },
  },
  name: "MatriculasIniciaisPorUnidade",
  mounted() {
    this.getQtd(this.franquiaId);
  },
  watch: {
    franquiaId(value) {
      this.loading = true;
      this.getQtd(value);
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    anoAtual() {
      return this.user.ano.descricao;
    },
  },
  data() {
    return {
      qtd: 0,
      loading: true,
    };
  },
  methods: {
    async getQtd(franquia) {
      const response = await this.$services.matriculasService.qtdIniciaisPorFranquia(franquia);
      this.qtd = response.qtd;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.dashboard-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  border-top: 4px solid #fbbb14;
}

.dashboard-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.card-header {
  padding-bottom: 0;
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.card-content {
  height: calc(100% - 48px);
}

.text-h3 {
  line-height: 1.2;
}
.primary--text {
  color: #1976d2 !important;
}
</style>
